// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP



// status
export const SHOW_LOADER = 'SHOW_LOADER';

export function showLoader(value) {
  return { type: SHOW_LOADER, result: value };
}


// WEBPACK FOOTER //
// ./src/js/actions/status.js